export enum MAP_EVENT_TYPE {
    FEATURE_UPDATED = 'featureUpdated',
    MAP_VERTEX_CHANGED = 'mapVertexChanged',
    SELECTED_FEATURE = 'selectedFeature'
}
